import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Expressions DSL",
description: "Introduces the Expressions DSL used as an example for Freon’s interpreter framework, explaining its structure, expression concepts, and function definitions.",
tags: [ "expressions", "DSL", "interpreter", "AST", "numeric expressions", "functions", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.389Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};